import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import styles from "./ItSolution.module.css"
import Model from '../../model/Model'
import GlobalStorage from '../../../Storage/ContextProvider'

export function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = useState(false)


    const observer = useMemo(() => new IntersectionObserver(
        ([entry]) => setIntersecting(entry.isIntersecting)
    ), [ref])


    useEffect(() => {
        observer.observe(ref.current)
        return () => observer.disconnect()
    }, [])
    // //console.log(isInters ecting);
    return isIntersecting
}

function ItSolution() {
    const ref = useRef()
    const isVisible = useOnScreen(ref)
    const { showModel, setShowModel, which, setWhich } = useContext(GlobalStorage)

    useEffect(() => {

    })
    return (
        <div ref={ref} className={`${styles.itSolutionmain} `}

        >


            <div data-aos='slide-left' className={styles.ItolutioninnerContainer}>
                <h1>IT SOLUTIONS</h1>
                <div className={styles.Itolutioninner}>
                    <div className={styles.ServiceLeft}>





                        <div className={styles.puffincenter}>
                            <p>IT関連の領域に関しては、非常に幅 <br /> 広く手掛けております。</p>
                            <br />

                            <p>ITに関するものであれば、御社の抱える問 <br /> 題を分解し、それらの問題を 効率よく解決する方法をともに考え、提案させていただきます。</p>
                            <br />
                            <p>AIからIoTまで最新の技術に関するご相談もお任せください。</p>


                        </div>
                    </div>
                    <div className={styles.ServiceRight}>
                        <div className={styles.gridBUtton}>
                            <button onClick={() => { setWhich('web'); setShowModel(true) }} >webサイト制作</button>
                        </div>
                        <div className={styles.gridBUtton}>
                            <button onClick={() => { setWhich('web2'); setShowModel(true) }}>webシステム開発</button>
                        </div>
                        <div className={styles.gridBUtton}>
                            <button onClick={() => { setWhich('mobile'); setShowModel(true) }}>アプリ開発</button>
                        </div>
                        <div className={styles.gridBUtton}>
                            <button onClick={() => { setWhich('AIアルゴリズム開発'); setShowModel(true) }}>AIアルゴリズム開発</button>
                        </div>
                        <div className={styles.gridBUtton}>
                            <button onClick={() => { setWhich('web3'); setShowModel(true) }}>web3.0</button>
                        </div>
                        <div className={styles.gridBUtton}>
                            <button>and more.</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ItSolution